import { BlogPost, FAQItem } from '../types'

export const blogPosts: BlogPost[] = [
  {
    id: 'how-to-choose-pool',
    title: 'Як обрати басейн для дачі: повний гайд',
    excerpt:
      'Розбираємо всі типи басейнів — каркасні, надувні та стаціонарні. Допоможемо визначитися з розміром та комплектацією.',
    image: 'https://images.unsplash.com/photo-1575429198097-0414ec08e8cd?w=800',
    category: 'Вибір обладнання',
    date: '15 березня 2024',
    readTime: '8 хв',
  },
  {
    id: 'water-chemistry-basics',
    title: 'Хімія для басейну: що потрібно знати новачку',
    excerpt:
      'Основи догляду за водою в басейні. pH, хлор, альгіциди — пояснюємо простими словами.',
    image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=800',
    category: 'Догляд за басейном',
    date: '10 березня 2024',
    readTime: '6 хв',
  },
  {
    id: 'pool-opening-spring',
    title: 'Відкриття басейну навесні: покрокова інструкція',
    excerpt:
      'Як правильно підготувати басейн до сезону після зимової консервації. Чек-лист та поради.',
    image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=800',
    category: 'Поради',
    date: '1 березня 2024',
    readTime: '5 хв',
  },
  {
    id: 'filter-maintenance',
    title: 'Обслуговування фільтра: коли і як чистити',
    excerpt:
      'Регулярне обслуговування фільтра — запорука чистої води. Розповідаємо про всі типи фільтрів.',
    image: 'https://images.unsplash.com/photo-1572331165267-854da2b021aa?w=800',
    category: 'Догляд за басейном',
    date: '25 лютого 2024',
    readTime: '7 хв',
  },
  {
    id: 'sauna-benefits',
    title: "Користь сауни для здоров'я: що каже наука",
    excerpt:
      'Наукові дослідження про вплив сауни на організм. Як правильно паритися для максимальної користі.',
    image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800',
    category: 'Поради',
    date: '20 лютого 2024',
    readTime: '10 хв',
  },
  {
    id: 'ice-bath-guide',
    title: 'Крижанні вани: гайд для початківців',
    excerpt:
      "Все про загартування холодом. Як почати, скільки часу проводити та які переваги для здоров'я.",
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800',
    category: 'Поради',
    date: '15 лютого 2024',
    readTime: '6 хв',
  },
]

export const faqItems: FAQItem[] = [
  // Замовлення
  {
    id: 'faq-1',
    question: 'Як оформити замовлення?',
    answer:
      "Додайте товари в кошик, перейдіть до оформлення та заповніть контактні дані. Ми зв'яжемося з вами для підтвердження замовлення протягом 30 хвилин у робочий час.",
    category: 'Замовлення',
  },
  {
    id: 'faq-2',
    question: 'Чи можна замовити товар, якого немає в наявності?',
    answer:
      "Так, ви можете залишити заявку на товар. Ми повідомимо вас, коли він з'явиться на складі. Зазвичай термін очікування — 5-14 робочих днів.",
    category: 'Замовлення',
  },
  {
    id: 'faq-3',
    question: 'Як відстежити статус замовлення?',
    answer:
      'Після відправлення ви отримаєте SMS та email з номером ТТН. Відстежити посилку можна на сайті Нової Пошти або в нашому Telegram.',
    category: 'Замовлення',
  },
  // Доставка
  {
    id: 'faq-4',
    question: 'Які способи доставки доступні?',
    answer:
      "Доставляємо по всій Україні Новою Поштою (у відділення або кур'єром). Для великогабаритних товарів доступна адресна доставка вантажним відділенням.",
    category: 'Доставка',
  },
  {
    id: 'faq-5',
    question: 'Скільки коштує доставка?',
    answer:
      'Вартість доставки розраховується за тарифами Нової Пошти. При замовленні від 5000 грн — безкоштовна доставка у відділення.',
    category: 'Доставка',
  },
  {
    id: 'faq-6',
    question: 'Як швидко відправляєте замовлення?',
    answer:
      'Замовлення, оформлені до 14:00, відправляємо того ж дня. Пізніші замовлення — наступного робочого дня.',
    category: 'Доставка',
  },
  // Оплата
  {
    id: 'faq-7',
    question: 'Які способи оплати доступні?',
    answer:
      'Приймаємо оплату карткою онлайн (Visa, Mastercard), накладений платіж при отриманні, безготівковий розрахунок для юридичних осіб.',
    category: 'Оплата',
  },
  {
    id: 'faq-8',
    question: 'Чи можна оплатити частинами?',
    answer:
      'Так, доступна оплата частинами від ПриватБанку та Monobank на товари від 1000 грн. Оберіть цей спосіб при оформленні.',
    category: 'Оплата',
  },
  // Гарантія
  {
    id: 'faq-9',
    question: 'Яка гарантія на товари?',
    answer:
      'На все обладнання діє офіційна гарантія виробника від 12 до 36 місяців. На хімію та витратні матеріали — гарантія якості до закінчення терміну придатності.',
    category: 'Гарантія',
  },
  {
    id: 'faq-10',
    question: 'Як повернути товар?',
    answer:
      'Повернення можливе протягом 14 днів з моменту отримання. Товар має бути в оригінальній упаковці без слідів використання. Зверніться до нас у Telegram для оформлення.',
    category: 'Гарантія',
  },
  // Монтаж
  {
    id: 'faq-11',
    question: 'Чи надаєте послуги монтажу?',
    answer:
      'Так, наші спеціалісти виконують монтаж басейнів, обладнання та саун в Івано-Франківську та області. Вартість залежить від складності робіт.',
    category: 'Монтаж',
  },
  {
    id: 'faq-12',
    question: 'Чи допоможете підібрати комплект обладнання?',
    answer:
      "Звичайно! Напишіть нам у Telegram з параметрами вашого басейну (об'єм, тип), і ми підберемо оптимальний комплект фільтрації, хімії та аксесуарів.",
    category: 'Монтаж',
  },
]
